/**
 * Função genérica para montar query params:
 * - Recebe um objeto (por exemplo, o `segment`) e a paginação.
 * - Para cada campo do objeto, caso tenha valor, faz append no params.
 * - Para array, converte em string separada por vírgula (ajuste conforme sua necessidade).
 * - Por fim, adiciona a paginação.
 */
export function buildQueryParams<T extends object>(formData: T | null): string {
  const params = new URLSearchParams();

  // Se não houver formData, só adiciona a paginação
  if (!formData) {
    return params.toString();
  }

  // Itera sobre cada [chave, valor] do objeto
  for (const [key, value] of Object.entries(formData)) {
    // Ignora caso seja null, undefined ou string vazia (ajuste conforme sua necessidade)
    if (value === null || value === undefined || value === "") {
      continue;
    }

    // Se for array, converte em uma única string separada por vírgula
    if (Array.isArray(value)) {
      params.append(key, value.join(","));
    } else {
      // Para outros tipos, adiciona diretamente como string
      params.append(key, String(value));
    }
  }

  return params.toString();
}
